import { EAlignTypes, EJustifyTypes } from '@constants';
import { Badge as AntdBadge, Flex } from 'antd';

type BadgeProps = {
  count: number;
  align?: EAlignTypes;
  justify?: EJustifyTypes;
};

export const Badge: React.FC<BadgeProps> = ({
  count,
  align = EAlignTypes.CENTER,
  justify = EJustifyTypes.CENTER
}) => {
  return (
    <Flex align={align} justify={justify}>
      <AntdBadge count={count} />
    </Flex>
  );
};
